import React from 'react'
import s from './HeaderDetail.less'
import classNames from 'classnames'
import { PAGE_CLASSES } from '../../routes/pageClasses.constants'
import { ClosePopinButtonGE } from '../genericComponents/ClosePopinButton'

export const HeaderDetail = ({ children, className }) => {
  return (
    <div className={classNames(s.HeaderDetail, className, PAGE_CLASSES.headerDetail)}>
      <ClosePopinButtonGE />
      {children}
    </div>
  )
}

export default HeaderDetail
